if (!customElements.get('featured-recommendations-pdp')) {
    customElements.define(
        'featured-recommendations-pdp',
        class extends HTMLElement {
            connectedCallback() {
                if (this.dataset.initialized === 'true') return;
                this.dataset.initialized = 'true';

                const hasSliderMarkup = this.querySelector('.featured-recommendations-swiper');
                const hasGridMarkup = this.querySelector('.product-grid-border-fix');
                const hasEmptyState = this.querySelector('.featured-recommendations-empty');

                if (hasSliderMarkup || hasGridMarkup || hasEmptyState) {
                    this.initExistingContent();
                    return;
                }

                this.load();
            }

            async initExistingContent() {
                await this.initSlider();
            }

            async load() {
                const url = this.dataset.url;
                if (!url) return;

                try {
                    const response = await fetch(url);
                    const text = await response.text();

                    const html = document.createElement('div');
                    html.innerHTML = text;

                    const content = html.querySelector('featured-recommendations-pdp, product-recommendations');
                    if (!content) return;

                    this.innerHTML = content.innerHTML;

                    await this.initSlider();
                } catch (error) {
                    console.error('Product recommendations error:', error);
                }
            }

            async initSlider() {
                if (this.dataset.enableSlider !== 'true') return;
              
                const slider = this.querySelector('.featured-recommendations-swiper');
                if (!slider) return;
              
                if (slider.classList.contains('swiper-initialized')) return;
              
                await this.loadSwiper();
              
                if (typeof Swiper === 'undefined') {
                  console.error('Swiper is not available');
                  return;
                }
              
                new Swiper(slider, {
                  slidesPerView: 4.5,
                  spaceBetween: 0,
                  grabCursor: true,
                  slidesPerGroup: 1,
                  mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                    releaseOnEdges: true,
                    sensitivity: 1
                  },
                  breakpoints: {
                    0: { slidesPerView: 1.5 },
                    769: { slidesPerView: 2.5 },
                    1025: { slidesPerView: 4.5 }
                  }
                });
              }
            loadSwiper() {
                if (window.Swiper) return Promise.resolve();

                if (window.__featuredRecommendationsSwiperPromise) {
                    return window.__featuredRecommendationsSwiperPromise;
                }

                window.__featuredRecommendationsSwiperPromise = new Promise((resolve, reject) => {
                    const existingScript = document.querySelector('script[data-featured-recommendations-swiper]');

                    if (existingScript) {
                        existingScript.addEventListener('load', () => resolve(), { once: true });
                        existingScript.addEventListener('error', reject, { once: true });
                        return;
                    }

                    const script = document.createElement('script');
                    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                    script.async = true;
                    script.setAttribute('data-featured-recommendations-swiper', '');
                    script.onload = () => resolve();
                    script.onerror = reject;

                    document.head.appendChild(script);
                });

                return window.__featuredRecommendationsSwiperPromise;
            }
        }
    );
}